// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__2tCbG","text":"text__2EkIj","error":"error__2MaNn","button-wrapper":"button-wrapper__12gg_","button":"button__2FCW-"};